var attrUrl = PSSessions.Cookies('PSAttrUrl');
var attrReferrer = PSSessions.Cookies('PSAttrReferrer');
var link = location.href;
var ref = document.referrer;
var setCookies = false;


if (!attrUrl && !attrReferrer) {
  setCookies = true;
  // if they have already been a PS visitor, tag as unknown
  // since we haven't tracked their initial referrer
  if (PSSessions.Cookies('PSState')) {
    link = 'unknown';
    ref = 'unknown';
  }
} else {
  var oldCampaign = -1 === attrUrl.indexOf('utm_') ? false : true;
  var newCampaign = -1 === link.indexOf('utm_') ? false : true;
  var peerspaceReferrer = -1 !== ref.indexOf('peerspace.com');
  // considered a PS overwrite if there is an existing referrer
  // already set when a peerspace.com referrer is detected
  var peerspaceOverwrite = attrReferrer && peerspaceReferrer;
  // we are only counting a new referrer url - like organic search from google
  // if there isn't already campaign info. we don't want to wipe that out
  // also, don't count self referrals from the blog / boards / tastemakers /
  // support unless it's the first referral (2/28 update)
  var newReferrer = ref && !peerspaceOverwrite && !oldCampaign;
  setCookies = newCampaign || newReferrer;
}

if (setCookies) {
  // expires in 45 days
  PSSessions.Cookies.set('PSAttrUrl', link, Date.now() + 3888000000);
  PSSessions.Cookies.set('PSAttrReferrer', ref, Date.now() + 3888000000);
}
